/* eslint-disable no-async-promise-executor -- comment: This issue will be resolved when we implment frontiers printing. */
import { useEffect, useState } from 'react'

// eslint-disable-next-line import/no-cycle -- comment: this is a circular dependency, it will probably be resolved when we impliment frontier's printing
import { usePortraits } from '..'
import { convertImageToDataUrl, PORTRAIT_TYPES } from '../../helpers'

// Retrieve the urls of a given type (default is thumbnailSquare)
// for each person of a pedigree that has that url.
// Type can be a string or an array of strings representing the type or
// types of portrait to retrieve.
export function usePortraitUrls(pedigree, typeOrTypes, asDataUrls = true) {
  const portraits = usePortraits(pedigree)
  const [urlOrUrls, setUrlOrUrls] = useState({})

  useEffect(() => {
    let canceled = false

    if (!canceled && portraits) {
      const currentPortraitUrls = {}
      const imagePromises = Object.entries(portraits).map(([personId, { portrait }]) => {
        return new Promise(async (resolve) => {
          if (Array.isArray(typeOrTypes) && typeOrTypes.length) {
            currentPortraitUrls[personId] = {}
            const imageListPromises = typeOrTypes.map((currentType) => {
              return new Promise(async (listResolve) => {
                const src = portrait?.portraitUrls?.[currentType]
                currentPortraitUrls[personId][currentType] = asDataUrls ? await convertImageToDataUrl(src) : src
                listResolve()
              })
            })
            Promise.all(imageListPromises).then(() => {
              resolve()
            })
          } else {
            const src = portrait?.portraitUrls?.[typeOrTypes ?? PORTRAIT_TYPES.thumbnailSquare]
            currentPortraitUrls[personId] = asDataUrls ? await convertImageToDataUrl(src) : src
            resolve()
          }
        })
      })

      Promise.all(imagePromises).then(() => {
        if (!canceled) {
          setUrlOrUrls(currentPortraitUrls)
        }
      })
    }

    return () => {
      canceled = true
    }
  }, [asDataUrls, portraits, typeOrTypes])

  return urlOrUrls
}

export default usePortraitUrls
